/** Export the exact SVG produced by the shared Lugsail preview renderer. */
export function downloadCanvasChartSvg(chartId, title = 'lugsail-chart') {
  const selector = `[data-canvas-chart-id="${chartId}"] svg`
  const source = document.querySelector(selector)
  if (!source) return false

  const svg = source.cloneNode(true)
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
  svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')
  const contents = new XMLSerializer().serializeToString(svg)
  const blob = new Blob([contents], { type: 'image/svg+xml;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${String(title).trim().replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'lugsail-chart'}.svg`
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
  return true
}
